__turbopack_context__.v({
  "freeShipping": "styles-module__hg9moq__freeShipping",
});
